import React from 'react';

export type ConversationConnectionState = 'connected' | 'connecting' | 'error';

interface ConversationHeaderBrandProps {
  isDarkMode: boolean;
  title: string;
  brandIconSrc: string;
  brandIconAlt: string;
  onHomeClick: () => void;
  subtitle?: string;
  connectionState?: ConversationConnectionState;
}

const statusStyles: Record<ConversationConnectionState, string> = {
  connected: 'bg-[#e7f5f1] text-[#11607d] dark:bg-[#11607d]/30 dark:text-[#28d1a2]',
  connecting: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  error: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
};

const statusDotStyles: Record<ConversationConnectionState, string> = {
  connected: 'bg-[#28d1a2]',
  connecting: 'bg-yellow-500 animate-pulse',
  error: 'bg-red-500',
};

const statusLabels: Record<ConversationConnectionState, string> = {
  connected: 'Verbunden',
  connecting: 'Verbinde...',
  error: 'Fehler',
};

export const ConversationHeaderBrand: React.FC<ConversationHeaderBrandProps> = ({
  isDarkMode,
  title,
  brandIconSrc,
  brandIconAlt,
  onHomeClick,
  subtitle = 'KI-gestützte virtuelle Ansprechperson',
  connectionState,
}) => {
  return (
    <div className="conversation-header-brand flex min-w-0 items-center gap-3">
      <button
        onClick={onHomeClick}
        className="conversation-header-home w-8 h-8 rounded-lg flex items-center justify-center hover:shadow-lg transition-all hover:scale-105"
        style={{ backgroundColor: '#F3F4F6' }}
        title="Back to home"
      >
        <img
          src={brandIconSrc}
          alt={brandIconAlt}
          className="w-5 h-5 object-contain"
        />
      </button>
      <div className="conversation-header-copy min-w-0">
        <h1 className={`conversation-header-title text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
          <span className="conversation-header-title-text block truncate">{title}</span>
        </h1>
        <p className={`conversation-header-subtitle hidden text-sm sm:flex items-center gap-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
          {subtitle}
          {connectionState && (
            <span className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full transition-colors ${statusStyles[connectionState]}`}>
              <span className={`w-2 h-2 rounded-full ${statusDotStyles[connectionState]}`} />
              {statusLabels[connectionState]}
            </span>
          )}
        </p>
      </div>
    </div>
  );
};
